import _throttle2 from "lodash/throttle";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import classNames from 'classnames';
import { HEADER_MAIN, HEADER_CATEGORY, HEADER_SEARCH_RESULTS, FOOTER_MAIN, FOOTER_PRODUCT, HEADER_PRODUCT_LISTING, SCROLL_DIRECTION } from 'swag-client-common/utils/constants';
import PopupManager from 'swag-client-common/containers/popup-manager';
import NotificationManager from 'swag-client-common/containers/notification-manager';
import LoadingOverlay from 'swag-client-common/components/ui/loading-overlay';
import Overlay from 'swag-client-common/components/ui/overlay';
import { OverlayType } from 'swag-client-common/components/ui/overlay/overlay';
import AdminAsUserWidget from 'swag-client-common/components/partials/admin-as-user-widget';
import { StickyContainer, Sticky } from 'react-sticky-modified';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import NotFoundPartial from 'swag-client-common/components/partials/not-found';
import { FooterMain } from 'swag-client-common/components/partials/footer-main';
import { PermissionErrorPopup } from 'swag-client-common/components/permission-error-popup';
import LoginPopup from '../popups/login-popup';
import { SignupPopup } from '../popups/signup-popup';
import RequestDemoPopup from '../popups/request-demo-popup';
import PromoPageStartingPopup from '../popups/promo-page-starting-popup';
import ForgotPasswordPopup from '../popups/forgot-password-popup';
import { Header, SearchResultsPageHeader } from './components/header';
import Caption from './components/caption';
import AdviceBanner from './components/advice-banner';
import ChatboxManager from './components/chatbox-manager';
import { WeMadeThis } from './components/we-made-this';
import { SwagFAQ } from './components/swag-faq';
import Helmet from './components/helmet';
import classes from './page.scss';
import { popupsDictionary } from './popup-settings';
import { getCustomInkFooter } from './components/page-custom-ink-footer';
const style = {
  sticky: {
    zIndex: 10
  }
};
let lastScroll = 0;
let scrollDirection;
let scrollWhenChangedDirection = 0;
let promoTimeout;
export class PageComponent extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      sticky: false,
      isCategoriesSticky: true,
      isCustomInkScriptLoaded: false
    });
    _defineProperty(this, "throttledOnScrollHandler", void 0);
    _defineProperty(this, "onScrollHandler", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > lastScroll && scrollDirection !== SCROLL_DIRECTION.down) {
        scrollDirection = SCROLL_DIRECTION.down;
        scrollWhenChangedDirection = currentScroll;
      }
      if (currentScroll < lastScroll && scrollDirection !== SCROLL_DIRECTION.up) {
        scrollDirection = SCROLL_DIRECTION.up;
        scrollWhenChangedDirection = currentScroll;
      }
      if (currentScroll > scrollWhenChangedDirection + 120) {
        if (this.state.isCategoriesSticky) {
          this.handleStickyStateCategoriesChange(false);
        }
      }
      if (currentScroll < scrollWhenChangedDirection - 50 || currentScroll < 120) {
        if (!this.state.isCategoriesSticky) {
          this.handleStickyStateCategoriesChange(true);
        }
      }
      lastScroll = currentScroll;
    });
    _defineProperty(this, "handleStickyStateCategoriesChange", isCategoriesSticky => {
      const {
        doNotUseSticky
      } = this.props;
      const isMobileView = isMobile();
      if (doNotUseSticky || isMobileView) {
        return this.setState({
          isCategoriesSticky: false
        });
      }
      this.setState({
        isCategoriesSticky
      });
    });
    _defineProperty(this, "handleStickyStateChange", sticky => {
      const {
        doNotUseSticky
      } = this.props;
      const isMobileView = isMobile();
      if (doNotUseSticky || isMobileView) {
        return this.setState({
          sticky: false
        });
      }
      this.setState({
        sticky
      });
    });
    _defineProperty(this, "getRootClassName", () => {
      var _window$location, _window$location$path, _window$location$path2, _window$location$path3, _window$location$path4;
      const {
        withPurpleWave = false
      } = this.props;
      if (!withPurpleWave) {
        return classes.root;
      }
      const page = ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : (_window$location$path = _window$location.pathname) === null || _window$location$path === void 0 ? void 0 : (_window$location$path2 = _window$location$path.split('/')) === null || _window$location$path2 === void 0 ? void 0 : (_window$location$path3 = _window$location$path2.filter(Boolean)) === null || _window$location$path3 === void 0 ? void 0 : (_window$location$path4 = _window$location$path3.shift()) === null || _window$location$path4 === void 0 ? void 0 : _window$location$path4.split('?').shift()) || '';
      return classNames(classes.root, {
        [classes.wave]: withPurpleWave,
        [classes[page]]: withPurpleWave && !!classes[page]
      });
    });
    this.throttledOnScrollHandler = _throttle2(this.onScrollHandler, 250);
  }
  componentDidMount() {
    const {
      promoPageStartingPopup,
      promoPageStartingPopupConfig,
      showPromoPagePopup
    } = this.props;
    this.props.loadAdditionalScripts();
    window.addEventListener('scroll', this.throttledOnScrollHandler);
    if (promoPageStartingPopup) {
      const {
          startingDelay: delay
        } = promoPageStartingPopupConfig,
        rest = _objectWithoutProperties(promoPageStartingPopupConfig, ["startingDelay"]);
      promoTimeout = setTimeout(() => showPromoPagePopup(promoPageStartingPopup, rest), delay);
    }
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledOnScrollHandler);
    promoTimeout && clearTimeout(promoTimeout);
  }
  getPageClass() {
    const {
      headerIsTransparent,
      footer,
      isPageBlocked,
      isPageBlockedImmediately,
      header,
      isPageFound,
      pageClassName
    } = this.props;
    let footerModifier;
    switch (footer) {
      case FOOTER_MAIN:
        {
          const isMobileView = isMobile();
          const isProductPage = window.location.pathname.indexOf('product') !== -1;
          footerModifier = classNames(classes.footerMainPadding, {
            [classes.productFooter]: isMobileView && isProductPage
          });
          break;
        }
      case FOOTER_PRODUCT:
        {
          if (!isPageFound) {
            footerModifier = classes.footerMainPadding;
          }
          break;
        }
      default:
        footerModifier = null;
    }
    const transparency = headerIsTransparent ? classes.noPadding : null;
    const padding = header === HEADER_MAIN ? classes.addPadding : null;
    return classNames(classes.page, pageClassName, footerModifier, transparency, padding, {
      [classes.noScroll]: isPageBlocked || isPageBlockedImmediately
    });
  }
  getHeader() {
    const {
      sticky,
      isCategoriesSticky
    } = this.state;
    const {
      headerIsTransparent,
      showCategories = true,
      headerIsViolet,
      isLimitedEdition,
      header,
      headerLogoContent,
      headerLink,
      hideHeaderLinks,
      regularBrowseProductsLink,
      showPhoneInMobile,
      promoPage,
      isPageFound,
      headerIsSticky,
      isPageBlockedImmediately,
      isBoxButtonShown,
      buildBoxClick,
      isFilterOpened,
      showSuperSpeedButton,
      isPhoneShown = true
    } = this.props;
    switch (header) {
      case HEADER_CATEGORY:
        {
          const headerContent = /*#__PURE__*/React.createElement(Header, {
            headerIsSticky: true,
            isFilterOpened: isFilterOpened,
            isBoxButtonShown: isBoxButtonShown,
            sticky: sticky,
            isCategoriesSticky: true,
            promoPage: promoPage,
            headerLink: headerLink,
            isViolet: headerIsViolet,
            isLimitedEdition: isLimitedEdition,
            showCategories: showCategories || !isPageFound,
            hideHeaderLinks: hideHeaderLinks,
            transparent: headerIsTransparent,
            showPhoneInMobile: showPhoneInMobile,
            headerLogoContent: headerLogoContent,
            regularBrowseProductsLink: regularBrowseProductsLink,
            isPageBlockedImmediately: isPageBlockedImmediately,
            onBuildBoxClick: buildBoxClick,
            headerType: HEADER_CATEGORY,
            showSuperSpeedButton: showSuperSpeedButton,
            isPhoneShown: isPhoneShown
          });
          if (!headerIsSticky) {
            return /*#__PURE__*/React.createElement("div", null, headerContent);
          }
          return /*#__PURE__*/React.createElement(Sticky, {
            topOffset: 1,
            style: style.sticky,
            onStickyStateChange: this.handleStickyStateChange
          }, headerContent);
        }
      case HEADER_PRODUCT_LISTING:
        {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.productListingHeader
          }, /*#__PURE__*/React.createElement(Header, {
            isStuck: headerIsSticky,
            isFilterOpened: isFilterOpened,
            isBoxButtonShown: isBoxButtonShown,
            sticky: sticky,
            isCategoriesSticky: isCategoriesSticky,
            promoPage: promoPage,
            headerLink: headerLink,
            isViolet: headerIsViolet,
            showCategories: showCategories || !isPageFound,
            hideHeaderLinks: hideHeaderLinks,
            transparent: headerIsTransparent,
            showPhoneInMobile: showPhoneInMobile,
            headerLogoContent: headerLogoContent,
            regularBrowseProductsLink: regularBrowseProductsLink,
            isPageBlockedImmediately: isPageBlockedImmediately,
            onBuildBoxClick: buildBoxClick,
            headerType: HEADER_PRODUCT_LISTING,
            showSuperSpeedButton: showSuperSpeedButton,
            isPhoneShown: isPhoneShown
          }));
        }
      case HEADER_SEARCH_RESULTS:
        return /*#__PURE__*/React.createElement("div", {
          className: classes.searchResultsHeader
        }, /*#__PURE__*/React.createElement(SearchResultsPageHeader, {
          isStuck: headerIsSticky,
          isFilterOpened: isFilterOpened,
          sticky: sticky,
          isCategoriesSticky: isCategoriesSticky,
          promoPage: promoPage,
          headerLink: headerLink,
          isViolet: headerIsViolet,
          showCategories: showCategories || !isPageFound,
          hideHeaderLinks: hideHeaderLinks,
          transparent: headerIsTransparent,
          showPhoneInMobile: showPhoneInMobile,
          headerLogoContent: headerLogoContent,
          regularBrowseProductsLink: regularBrowseProductsLink,
          onBuildBoxClick: buildBoxClick,
          headerType: HEADER_SEARCH_RESULTS,
          showSuperSpeedButton: showSuperSpeedButton,
          isPhoneShown: isPhoneShown
        }));
      case null:
      default:
        return null;
    }
  }
  getPageContent() {
    const {
      isAdviceBannerShow,
      subCaption,
      caption,
      isPageFound = true,
      showEmptyPage = false
    } = this.props;
    if (!isPageFound) {
      return /*#__PURE__*/React.createElement("div", {
        className: this.getPageClass()
      }, /*#__PURE__*/React.createElement(NotFoundPartial, null));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: this.getPageClass()
    }, /*#__PURE__*/React.createElement(Caption, {
      mainText: caption,
      subText: subCaption
    }), showEmptyPage ? /*#__PURE__*/React.createElement("div", {
      className: classes.emptyPage
    }) : this.props.children, /*#__PURE__*/React.createElement(AdviceBanner, {
      isAdviceBannerShow: isAdviceBannerShow
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames({
        [classes.invisible]: !isAdviceBannerShow
      })
    }, /*#__PURE__*/React.createElement(WeMadeThis, null), /*#__PURE__*/React.createElement(SwagFAQ, null)));
  }
  getFooter() {
    const {
      footer,
      isPageFound
    } = this.props;
    const customFooter = getCustomInkFooter();
    if (customFooter) {
      return customFooter;
    }
    switch (footer) {
      case FOOTER_MAIN:
        {
          const isMobileView = isMobile();
          const isProductPage = window.location.pathname.indexOf('product') !== -1;
          return /*#__PURE__*/React.createElement(FooterMain, {
            footerClassName: classNames({
              [classes.footerMobile]: isMobileView && isProductPage
            })
          });
        }
      case FOOTER_PRODUCT:
        {
          if (!isPageFound) {
            return /*#__PURE__*/React.createElement(FooterMain, null);
          }
          return null;
        }
      case null:
      default:
        return null;
    }
  }
  render() {
    const {
      style,
      showLoadingOverlay,
      showSearchResultsOverlay,
      showCategories,
      autoChatbox,
      aboveHeaderElement,
      loading,
      isSuspenseFallback,
      useWavedLoader
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: this.getRootClassName(),
      style: style
    }, /*#__PURE__*/React.createElement(Helmet, null), /*#__PURE__*/React.createElement(AdminAsUserWidget, null), /*#__PURE__*/React.createElement(StickyContainer, null, aboveHeaderElement || null, this.getHeader(), this.getPageContent(), this.getFooter(), autoChatbox && /*#__PURE__*/React.createElement(ChatboxManager, null)), /*#__PURE__*/React.createElement(PopupManager, {
      popupsDictionary: popupsDictionary
    }), /*#__PURE__*/React.createElement(LoginPopup, {
      isSuspenseFallback: isSuspenseFallback
    }), /*#__PURE__*/React.createElement(SignupPopup, null), /*#__PURE__*/React.createElement(PromoPageStartingPopup, null), /*#__PURE__*/React.createElement(NotificationManager, null), /*#__PURE__*/React.createElement(RequestDemoPopup, null), /*#__PURE__*/React.createElement(ForgotPasswordPopup, null), /*#__PURE__*/React.createElement(PermissionErrorPopup, null), /*#__PURE__*/React.createElement(LoadingOverlay, {
      isShown: showLoadingOverlay || loading,
      wavedLoader: useWavedLoader
    }), /*#__PURE__*/React.createElement(Overlay, {
      isShown: showSearchResultsOverlay,
      overlayingType: showCategories ? OverlayType.searchOverlayWithCategories : OverlayType.searchOverlay
    }));
  }
}
_defineProperty(PageComponent, "defaultProps", {
  header: HEADER_CATEGORY,
  headerIsTransparent: false,
  headerIsViolet: false,
  caption: '',
  subCaption: '',
  footer: FOOTER_MAIN,
  autoChatbox: true,
  loading: false,
  isBoxButtonShown: true,
  showCategories: true,
  isSuspenseFallback: false,
  useWavedLoader: false
});